// Global Cookie Banner Script
(function() {
  'use strict';
  
  // Cookie utility functions
  function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  function getCookie(name) {
    const cname = name + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(cname) === 0) return c.substring(cname.length, c.length);
    }
    return "";
  }

  // Accept cookies function exposed to global scope
  window.acceptCookies = function() {
    setCookie("cookiesAccepted", "true", 365);
    const banner = document.getElementById("cookie-banner");
    if (banner) {
      banner.style.display = "none";
    }
  };

  // Initialize cookie banner
  function initCookieBanner() {
    if (!getCookie("cookiesAccepted")) {
      const banner = document.getElementById("cookie-banner");
      if (!banner) return;
      
      const lang = navigator.language || navigator.userLanguage;
      banner.style.display = "block";
      
      if (lang.startsWith("ar")) {
        const arMessage = document.getElementById("cookie-message-ar");
        if (arMessage) arMessage.style.display = "inline";
        banner.style.direction = "rtl";
      } else {
        const enMessage = document.getElementById("cookie-message-en");
        if (enMessage) enMessage.style.display = "inline";
        banner.style.direction = "ltr";
      }
    }
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCookieBanner);
  } else {
    initCookieBanner();
  }
})(); 